import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SwitchCasesDirective } from '@core/directives/SwitchCases.directive';
import { FileExtensionPipe } from '@core/pipes/fileExtention.pipe';

@Component({
  selector: 'app-fileimagepreview',
  standalone: true,
  imports: [
       CommonModule,
        FileExtensionPipe,
        SwitchCasesDirective,
  ],
  templateUrl: './fileimagepreview.component.html',
  styleUrl: './fileimagepreview.component.scss'
})
export class FileimagepreviewComponent {
  @Input() fileType: string | null = null;
}
